/**
 * Storage utilities with TTL support.
 *
 * Tries sessionStorage first, falls back to localStorage.
 * These are also defined as inline globals in templates/components/scripts/storage-utils.html
 * so they are available before the webpack bundle loads.
 */

export function setWithExpiry(key, value, ttl = null, locationToSave = 'session') {
    const now = Date.now();
    const item = {
        value: value,
        // if ttl is provided and is a finite number, compute expiry; else use null to mean "never"
        expiry: (typeof ttl === 'number' && isFinite(ttl)) ? now + ttl : null,
    };

    const json = JSON.stringify(item);
    if (locationToSave === 'local') {
        localStorage.setItem(key, json);
    } else {
        // default to sessionStorage
        sessionStorage.setItem(key, json);
    }
}

export function getWithExpiry(key) {
    // try sessionStorage first
    let itemStr = sessionStorage.getItem(key);
    let storage = 'session';

    if (itemStr === null) {
        // fallback to localStorage
        itemStr = localStorage.getItem(key);
        storage = 'local';
        if (itemStr === null) {
            return null; // not found anywhere
        }
    }

    let item;
    try {
        item = JSON.parse(itemStr);
    } catch (e) {
        console.warn(`Could not parse storage item '${key}':`, e);
        // corrupt JSON — remove it and bail
        storage === 'local'
            ? localStorage.removeItem(key)
            : sessionStorage.removeItem(key);
        return null;
    }

    const now = Date.now();
    // if expiry is a number, check it; if it's null, treat as never expires
    if (typeof item.expiry === 'number') {
        if (now > item.expiry) {
            // expired — remove and return null
            storage === 'local'
                ? localStorage.removeItem(key)
                : sessionStorage.removeItem(key);
            return null;
        }
    }

    // otherwise item.expiry === null → never expires
    return item.value;
}
